export default __webpack_public_path__ + "static/media/Instagram.844046f4.svg";